import main from '../scss/init.scss'; // eslint-disable-line no-unused-vars

// UI scripts
import { openSubmenu } from './custom/navigation.js';
import { toggleNavigation } from './custom/mobile-navigation.js';
import { initCustomSelect } from './custom/custom-select.js';
import { cookieMessage } from './custom/cookie-message.js';
import { initStickyNav } from './custom/sticky-nav.js';
import { initStickyNavMobile } from './custom/sticky-nav-mobile.js';
import { loadItems } from './custom/lazy-loading.js';
import { showFilters } from './custom/category-filters.js';
import { initStickySideNav } from './custom/sticky-side-nav.js';
import { toggleAccordion } from './custom/accordion.js';
import { toggleTagDropdown } from './custom/tag-dropdown.js';
import { triggerSearch } from './custom/search.js';
import { initResearchersResults } from './custom/researchers-results.js';
import { trackClickGa } from './custom/trigger-click-ga.js';

$(function() {
  openSubmenu();
  toggleNavigation();
  initCustomSelect();
  cookieMessage();
  initStickyNav();
  initStickyNavMobile();
  loadItems();
  videoPopupInit();
  imagePopupInit();
  showFilters();
  initStickySideNav();
  toggleAccordion();
  toggleTagDropdown();
  triggerSearch();
  initResearchersResults();
  trackClickGa();

  $('a[target="_blank"]').attr('rel', 'noopener noreferrer');

  $('#filter-nav').tinyNav({
    active: 'active',
  });

  if ($('.category-results .column').length < 5) {
    $('.category-results').addClass('show-all');
  }

  $(window).on('resize', function() {
    initStickySideNav();
  });

  $('.hero-area').each(function() {
    if ($('.feedback-box', this).length > 0) {
      $(this).addClass('send-feedback');
      $(this).prev('section').addClass('breadcrumb-top');
    }
  });

  $('.author-info .show-detail-info').on('click', function(event) {
    event.preventDefault();
    $(this).closest('.author-info').addClass('js-open-info');
  });
  $('.author-info .ico-close').on('click', function(event) {
    event.preventDefault();
    $(this).closest('.author-info').toggleClass('js-open-info');
  });
  $('.author-info .full-cover-back').on('click', function(event) {
    event.preventDefault();
    $(this).closest('.author-info').removeClass('js-open-info');
  });

  // go to anchor link
  $('a[href^="#"]').on('click', function(e) {
    var hash = this.hash;

    if (hash !== '') {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $(hash).offset().top - 70,
      }, 1200, function() {
      });
    }
  });

  function videoPopupInit() {
    $('.popup-video').magnificPopup({
      type: 'iframe',
      preloader: true,
    });

    $('.open-popup-link').magnificPopup({
      type: 'inline',
      showCloseBtn: false,
      midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    });

    $('.popup-close').on('click', function() {
      $.magnificPopup.close();
    });
  }

  function imagePopupInit() {
    $('.open-image').magnificPopup({
      type: 'image',
      closeBtnInside: true,
      closeOnContentClick: false,
    });
  }
});



// WEBPACK FOOTER //
// ./src/js/main.js